import React from "react";

import {
  FormContainer,
  FormContainerItem,
  SecondaryButton,
  SuccessBanner,
  WarningBanner,
} from "@graffer-inc/console-design-kit";

import type { ServiceAccountKey } from "../../../../../../application/domain/service-account/service-account";

type ServiceAccountKeyCreateSucceededProps = {
  serviceAccountKey: ServiceAccountKey;
  privateKeyPem: string;

  onClickToList: () => void;
};

export const ServiceAccountKeyCreateSucceeded: React.FC<
  ServiceAccountKeyCreateSucceededProps
> = ({ serviceAccountKey, privateKeyPem, onClickToList }) => {
  const [showBanner, setShowBanner] = React.useState<boolean>(true);

  const rawPrivateKeyPem = React.useMemo(() => {
    return atob(privateKeyPem);
  }, [privateKeyPem]);

  return (
    <div>
      {showBanner && (
        <div className="mb-5">
          <FormContainer>
            <FormContainerItem>
              <SuccessBanner
                message="サービスアカウントキーを作成しました"
                onClose={() => {
                  setShowBanner(false);
                }}
              />
            </FormContainerItem>
          </FormContainer>
        </div>
      )}

      <nav className="level">
        <div className="level-left"></div>
        <div className="level-right">
          <p className="level-item">
            <SecondaryButton text="一覧を表示" onClick={onClickToList} />
          </p>
        </div>
      </nav>

      <section>
        <div className="columns">
          <div className="column">
            <div className="field">
              <label className="label">キーID</label>
              <div className="control">
                <p>{serviceAccountKey.id}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="columns">
          <div className="column">
            <div className="field">
              <label className="label">秘密鍵</label>
              <div className="mb-2">
                <WarningBanner message="連携先の外部サービスが利用する秘密鍵です。この画面を離れると二度と表示されません。この画面でコピーし、安全な方法で外部サービスに渡してください。" />
              </div>
              <div className="control">
                <textarea
                  className="textarea"
                  value={rawPrivateKeyPem}
                  rows={30}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
